import { cn } from "@/lib/utils";
import { UserButton, useUser } from "@clerk/clerk-react";
import { Menu, Shield, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { MobileNav } from "./MobileNav";

export function Header() {
	const { t } = useTranslation();
	const { user } = useUser();
	const location = useLocation();
	const [mobileOpen, setMobileOpen] = useState(false);
	const isAdmin = user?.publicMetadata?.role === "admin";

	const navLinks = [
		{ href: "/", label: t("nav.dashboard") },
		{ href: "/courses", label: t("nav.courses") },
	];

	return (
		<>
			<header className="sticky top-0 z-sticky glass-surface">
				<div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 lg:px-8">
					<div className="flex items-center gap-8">
						<Link to="/" className="flex items-center gap-2 text-lg font-bold text-primary">
							<img src="/logo.svg" alt="" className="h-7 w-7" aria-hidden="true" />
							Telemetry Drops
						</Link>
						<nav className="hidden items-center gap-1 md:flex" aria-label="Main navigation">
							{navLinks.map((link) => {
								const active = location.pathname === link.href;
								return (
									<Link
										key={link.href}
										to={link.href}
										aria-current={active ? "page" : undefined}
										className={cn(
											"rounded-md px-3 py-2 text-sm font-medium transition-colors",
											active ? "text-accent" : "text-secondary hover:text-primary",
										)}
									>
										{link.label}
									</Link>
								);
							})}
							{isAdmin && (
								<Link
									to="/admin"
									aria-current={location.pathname.startsWith("/admin") ? "page" : undefined}
									className={cn(
										"flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors",
										location.pathname.startsWith("/admin")
											? "text-accent"
											: "text-secondary hover:text-primary",
									)}
								>
									<Shield className="h-4 w-4" aria-hidden="true" />
									{t("nav.admin")}
								</Link>
							)}
						</nav>
					</div>
					<div className="flex items-center gap-4">
						<UserButton afterSignOutUrl="/" />
						<button
							type="button"
							onClick={() => setMobileOpen(!mobileOpen)}
							className="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md text-secondary hover:text-primary md:hidden"
							aria-label={mobileOpen ? "Close menu" : "Open menu"}
							aria-expanded={mobileOpen}
						>
							{mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
						</button>
					</div>
				</div>
			</header>
			<MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} isAdmin={isAdmin} />
		</>
	);
}
